import { render, staticRenderFns } from "./DettaglioOrario.vue?vue&type=template&id=c7543772&"
import script from "./DettaglioOrario.vue?vue&type=script&lang=js&"
export * from "./DettaglioOrario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports